import { get, remove, set } from 'lib/storage/versionedLocalStorageUtils'

// Redux state
// Increment version when we change the state structure in an incompatible way.
const REDUX_SELECTED_TRAVELLER_STATE_KEY = 'BusinessTravellerSelectedTraveller'
const REDUX_SELECTED_TRAVELLER_STATE_VERSION = 2

type BusinessTravellerSelectedTravellerState = {
  employeeIds?: Array<string>
  guestCount?: number
} | undefined

export function saveBusinessTravellerSelectedTravellerState(employeeIds: Array<string>, guestCount?: number) {
  set(REDUX_SELECTED_TRAVELLER_STATE_KEY, REDUX_SELECTED_TRAVELLER_STATE_VERSION, { employeeIds, guestCount: guestCount ?? 0 })
}

export function getBusinessTravellerSelectedTravellerState(): BusinessTravellerSelectedTravellerState {
  return get(REDUX_SELECTED_TRAVELLER_STATE_KEY, REDUX_SELECTED_TRAVELLER_STATE_VERSION)
}

export function clearBusinessTravellerSelectedTraveller() {
  remove(REDUX_SELECTED_TRAVELLER_STATE_KEY)
}

// Mapping trip request traveller details to the traveller form on checkout page.
// Used to pre-fill traveller forms with details from the trip request during cart restoration
const TRIP_REQUEST_TRAVELLER_FORM_MAPPING_KEY = 'BusinessTravellerTripRequestTravellerFormMapping'
const TRIP_REQUEST_TRAVELLER_FORM_MAPPING_VERSION = 1

type TripRequestTravellerFormMappingState = {
  travellerFormMappings: Array<App.BusinessTraveller.TripRequestTravellerFormMapping>
} | undefined

export function saveBusinessTravellerTripRequestTravellerFormMappings(travellerFormMappings: Array<App.BusinessTraveller.TripRequestTravellerFormMapping>) {
  set(TRIP_REQUEST_TRAVELLER_FORM_MAPPING_KEY, TRIP_REQUEST_TRAVELLER_FORM_MAPPING_VERSION, { travellerFormMappings })
}

export function getBusinessTravellerTripRequestTravellerFormMappings(): TripRequestTravellerFormMappingState {
  return get(TRIP_REQUEST_TRAVELLER_FORM_MAPPING_KEY, TRIP_REQUEST_TRAVELLER_FORM_MAPPING_VERSION)
}

export function clearBusinessTravellerTripRequestTravellerFormMappings() {
  remove(TRIP_REQUEST_TRAVELLER_FORM_MAPPING_KEY)
}
